import React from 'react';
import { Container, Paper, Typography, Button, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

// Після створення запису повертаємо гостя на головну лендінгу, а не appointMe
const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'http://localhost:5173';

export default function BookSuccess() {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Stack spacing={2} alignItems="center">
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
          <Typography variant="h5">{t('bookSuccess.title')}</Typography>
          <Typography color="text.secondary">
            {t('bookSuccess.text')}
          </Typography>
          <Button variant="contained" href={LANDING_URL}>
            {t('bookSuccess.backToSite')}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
